import type {
  ProductCollectionAggregationQuery,
  ProductCollectionAggregationQueryVariables,
} from 'src/types';
import productCollectionSearchQuery from '../search.graphql';
import { useGqlQuery } from 'src/hooks/use-gql-query';

export function useProductCollectionSearchQuery(
  variables: ProductCollectionAggregationQueryVariables
) {
  return useGqlQuery<ProductCollectionAggregationQuery>({
    query: productCollectionSearchQuery,
    queryKey: ['productCollectionAggregations'],
    variables,
    enabled: !!variables.aggregationId,
  });
}
